/**
 * Shared computation for the derived brand+name key fields every item doc
 * needs to be discoverable by aggregation queries.
 *
 * There are multiple Add[Type]Modal components that write user items
 * directly via addDoc (bypassing firebase/db.ts's shared `addItem`
 * function). Historically each modal computed `brandLower`/`nameLower`
 * inline, and the Phase 1 upgrade to also stamp `brandSlug`/`nameSlug`
 * only made it into `addItem`, leaving every direct-write modal invisible
 * to the community aggregation query (which filters by brandSlug +
 * nameSlug). This helper is the single source of truth so a future field
 * addition only touches one place.
 */
import { slugify } from './polishSlug';

export function itemDocKeys(brand: string | undefined, name: string | undefined) {
  const b = (brand ?? '').trim();
  const n = (name ?? '').trim();
  return {
    brandLower: b.toLowerCase(),
    nameLower: n.toLowerCase(),
    brandSlug: slugify(b),
    nameSlug: slugify(n),
  };
}
